import { Component } from '@angular/core';

@Component({
    selector: 'login-failed',
    templateUrl: './failed.component.html',
    standalone: true,
})
export class FailedComponent {
}
